import React, { useState } from "react";
import { Card, Button, ButtonGroup, Modal, Carousel } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Link } from "react-router-dom";
import screenshot1 from "../../Assets/Projects/hangmango/Simulator Screenshot - store - 2025-10-05 at 15.02.11.png";
import screenshot2 from "../../Assets/Projects/hangmango/Simulator Screenshot - store - 2025-10-05 at 15.02.13.png";
import screenshot3 from "../../Assets/Projects/hangmango/Simulator Screenshot - store - 2025-10-05 at 15.04.13.png";
import screenshot4 from "../../Assets/Projects/hangmango/Simulator Screenshot - store - 2025-10-05 at 15.04.33.png";
import screenshot5 from "../../Assets/Projects/hangmango/Simulator Screenshot - store - 2025-10-05 at 15.04.57.png";
import screenshot6 from "../../Assets/Projects/hangmango/Simulator Screenshot - store - 2025-10-05 at 15.05.03.png";
import screenshot7 from "../../Assets/Projects/hangmango/Simulator Screenshot - store - 2025-10-05 at 15.17.48.png";
import screenshot8 from "../../Assets/Projects/hangmango/Simulator Screenshot - store - 2025-10-05 at 15.17.50.png";
import screenshot9 from "../../Assets/Projects/hangmango/Simulator Screenshot - store - 2025-10-05 at 15.17.53.png";

const translations = {
  tr: {
    title: "Hangman Go - Adam Asmaca",
    description: "Türkçe, İngilizce, Almanca ve İspanyolca dillerinde oynanabilen kelime tahmin oyunu. Farklı zorluk seviyeleri, kategori seçenekleri, karakter özelleştirme ve tema kilidi açma sistemi ile eğlenceli bir mobil oyun deneyimi. React Native ile geliştirildi.",
    demo: "Demo",
    details: "Detaylar",
    privacy: "Gizlilik Politikası",
    terms: "Kullanım Şartları",
    modalTitle: "Hangman Go - Detaylı Bilgi",
    features: [
      "🌍 4 Dil Desteği: Türkçe, İngilizce, Almanca ve İspanyolca",
      "🎮 Çoklu Zorluk Seviyeleri: Kolay, Orta ve Zor",
      "📚 Çeşitli Kategoriler: Hayvanlar, yiyecekler, spor ve daha fazlası",
      "👤 Karakter Özelleştirme: Kendi karakterinizi yaratın",
      "🎨 Tema Sistemi: Oynarken yeni temaları kilidini açın",
      "📱 React Native ile geliştirildi: iOS ve Android desteği",
      "💯 Skor Sistemi: Yüksek skorunuzu takip edin",
      "🎯 Sezgisel ve kullanıcı dostu arayüz"
    ]
  },
  en: {
    title: "Hangman Go",
    description: "A multilingual word guessing game available in Turkish, English, German, and Spanish. Features multiple difficulty levels, category options, character customization, and theme unlocking system. Developed with React Native for an engaging mobile gaming experience.",
    demo: "Demo",
    details: "Details",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    modalTitle: "Hangman Go - Detailed Information",
    features: [
      "🌍 4 Language Support: Turkish, English, German, and Spanish",
      "🎮 Multiple Difficulty Levels: Easy, Medium, and Hard",
      "📚 Various Categories: Animals, food, sports, and more",
      "👤 Character Customization: Create your own character",
      "🎨 Theme System: Unlock new themes as you play",
      "📱 Built with React Native: iOS and Android support",
      "💯 Score System: Track your high scores",
      "🎯 Intuitive and user-friendly interface"
    ]
  },
  de: {
    title: "Hangman Go",
    description: "Ein mehrsprachiges Wortratespiel auf Türkisch, Englisch, Deutsch und Spanisch. Mit mehreren Schwierigkeitsgraden, Kategorieoptionen, Charakteranpassung und Themenfreischaltungssystem. Mit React Native entwickelt für ein spannendes mobiles Spielerlebnis.",
    demo: "Demo",
    details: "Details",
    privacy: "Datenschutzrichtlinie",
    terms: "Nutzungsbedingungen",
    modalTitle: "Hangman Go - Detaillierte Informationen",
    features: [
      "🌍 4 Sprachunterstützung: Türkisch, Englisch, Deutsch und Spanisch",
      "🎮 Mehrere Schwierigkeitsgrade: Einfach, Mittel und Schwer",
      "📚 Verschiedene Kategorien: Tiere, Essen, Sport und mehr",
      "👤 Charakteranpassung: Erstellen Sie Ihren eigenen Charakter",
      "🎨 Themensystem: Schalten Sie beim Spielen neue Themen frei",
      "📱 Mit React Native entwickelt: iOS- und Android-Unterstützung",
      "💯 Punktesystem: Verfolgen Sie Ihre Höchstpunktzahl",
      "🎯 Intuitive und benutzerfreundliche Oberfläche"
    ]
  },
  es: {
    title: "Hangman Go",
    description: "Un juego multilingüe de adivinanza de palabras disponible en turco, inglés, alemán y español. Con múltiples niveles de dificultad, opciones de categorías, personalización de personajes y sistema de desbloqueo de temas. Desarrollado con React Native para una experiencia de juego móvil atractiva.",
    demo: "Demo",
    details: "Detalles",
    privacy: "Política de Privacidad",
    terms: "Términos de Servicio",
    modalTitle: "Hangman Go - Información Detallada",
    features: [
      "🌍 Soporte de 4 idiomas: Turco, inglés, alemán y español",
      "🎮 Múltiples niveles de dificultad: Fácil, Medio y Difícil",
      "📚 Varias categorías: Animales, comida, deportes y más",
      "👤 Personalización de personajes: Crea tu propio personaje",
      "🎨 Sistema de temas: Desbloquea nuevos temas mientras juegas",
      "📱 Desarrollado con React Native: Soporte iOS y Android",
      "💯 Sistema de puntuación: Realiza un seguimiento de tus puntuaciones más altas",
      "🎯 Interfaz intuitiva y fácil de usar"
    ]
  }
};

const screenshots = [
  screenshot1,
  screenshot2,
  screenshot3,
  screenshot4,
  screenshot5,
  screenshot6,
  screenshot7,
  screenshot8,
  screenshot9
];

function HangmanGoCard({ imgPath }) {
  const [language, setLanguage] = useState("tr");
  const [showModal, setShowModal] = useState(false);
  const content = translations[language];

  return (
    <>
      <Card className="project-card-view">
        <Card.Img variant="top" src={imgPath} alt="card-img" />
        <Card.Body>
          <div style={{ marginBottom: "15px" }}>
            <ButtonGroup size="sm">
              <Button
                variant={language === "tr" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("tr")}
              >
                TR
              </Button>
              <Button
                variant={language === "en" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("en")}
              >
                EN
              </Button>
              <Button
                variant={language === "de" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("de")}
              >
                DE
              </Button>
              <Button
                variant={language === "es" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("es")}
              >
                ES
              </Button>
            </ButtonGroup>
          </div>
          <Card.Title>{content.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {content.description}
          </Card.Text>
          <Button
            variant="primary"
            onClick={() => setShowModal(true)}
          >
            <AiOutlineInfoCircle /> &nbsp;
            {content.details}
          </Button>
          <div style={{ marginTop: "10px" }}>
            <Button
              variant="outline-primary"
              as={Link}
              to="/privacy-policy"
              size="sm"
              style={{ marginRight: "5px" }}
            >
              {content.privacy}
            </Button>
            <Button
              variant="outline-primary"
              as={Link}
              to="/terms-of-service"
              size="sm"
            >
              {content.terms}
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#1a1a2e", color: "white" }}>
          <Modal.Title>{content.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#16213e", color: "white" }}>
          <Carousel>
            {screenshots.map((screenshot, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={screenshot}
                  alt={`Screenshot ${index + 1}`}
                  style={{ maxHeight: "500px", objectFit: "contain" }}
                />
              </Carousel.Item>
            ))}
          </Carousel>

          <div style={{ marginTop: "20px" }}>
            <h5 style={{ color: "#c770f0", marginBottom: "15px" }}>✨ {content.modalTitle.split(" - ")[1]}</h5>
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {content.features.map((feature, index) => (
                <li key={index} style={{ marginBottom: "10px", fontSize: "16px" }}>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#1a1a2e", borderTop: "1px solid #c770f0" }}>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default HangmanGoCard;
